import { render } from "./LojasAdesao.vue?vue&type=template&id=401bd996"
import script from "./LojasAdesao.vue?vue&type=script&lang=js"
export * from "./LojasAdesao.vue?vue&type=script&lang=js"
script.render = render

export default script